export const PurchaseProtectionIcon = (props) => (
  <svg
    className={props.className}
    width="17"
    height="19"
    viewBox="0 0 17 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.3 18.2C11.2 17.2 13 15.5 14 14.3C14.7 13.4 15.2 12.3 15.3 11.2L16.1 3H15.3C10.3 3 8.9 0.1 8.8 0H8.10001H7.39999C7.29999 0.1 5.9 3 0.900002 3H0L0.800003 11.2C0.900003 12.4 1.4 13.5 2.1 14.3C3.1 15.5 4.9 17.2 7.8 18.2H8.3ZM13.7 11C13.6 11.9 13.3 12.7 12.8 13.3C12 14.3 10.4 15.7 8 16.6C5.6 15.7 4.1 14.3 3.2 13.3C2.7 12.7 2.3 11.9 2.3 11L1.7 4.5C5.2 4.3 7.1 2.7 8 1.7C8.9 2.8 10.8 4.3 14.3 4.5L13.7 11Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.43419 6.95007H3.7002V5.45007H5.76621L5.89716 6.55008H12.3989L11.0634 11.1501H4.93419L4.43419 6.95007ZM6.07573 8.05008L6.26621 9.65007H9.93697L10.4015 8.05008H6.07573Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0002 13.05C10.2487 13.05 10.4502 12.8486 10.4502 12.6C10.4502 12.3515 10.2487 12.15 10.0002 12.15C9.75167 12.15 9.5502 12.3515 9.5502 12.6C9.5502 12.8486 9.75172 13.05 10.0002 13.05ZM8.9502 12.6C8.9502 12.0201 9.42035 11.55 10.0002 11.55C10.58 11.55 11.0502 12.0201 11.0502 12.6C11.0502 13.1799 10.5801 13.65 10.0002 13.65C9.4203 13.65 8.9502 13.1799 8.9502 12.6Z"
      fill="#34363E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.8 13.05C6.04848 13.05 6.25 12.8486 6.25 12.6C6.25 12.3515 6.04853 12.15 5.8 12.15C5.55145 12.15 5.35 12.3515 5.35 12.6C5.35 12.8486 5.5515 13.05 5.8 13.05ZM4.75 12.6C4.75 12.0201 5.22015 11.55 5.8 11.55C6.37988 11.55 6.85 12.0201 6.85 12.6C6.85 13.1799 6.37993 13.65 5.8 13.65C5.2201 13.65 4.75 13.1799 4.75 12.6Z"
      fill="#34363E"
    />
  </svg>
);
